import React, { useEffect, useState, useCallback } from 'react';
import './index.css';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Hero from './sections/Hero';
import About from './sections/About';
import HowItWorks from './sections/HowItWorks';
import NonProfits from './sections/NonProfits';
import PeopleInNeed from './sections/PeopleInNeed';
import Contact from './sections/Contact';
import Team from './sections/Team';
import tccLogo from './assets/images/tcc-logo.png';

/* ── 4. Scroll progress bar ── */
function ScrollProgress() {
  const [pct, setPct] = useState(0);
  const onScroll = useCallback(() => {
    const scrolled = window.scrollY;
    const total = document.documentElement.scrollHeight - window.innerHeight;
    setPct(total > 0 ? (scrolled / total) * 100 : 0);
  }, []);
  useEffect(() => {
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [onScroll]);
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, height: '3px', zIndex: 99999, background: 'rgba(63,196,227,0.12)' }}>
      <div style={{
        height: '100%', width: `${pct}%`,
        background: 'linear-gradient(90deg, #3FC4E3, #006077)',
        transition: 'width 60ms linear',
        boxShadow: '0 0 10px rgba(63,196,227,0.7)',
      }} />
    </div>
  );
}

function Preloader({ done }) {
  return (
    <div
      className={done ? 'preloader-fade' : ''}
      style={{
        position: 'fixed',
        inset: 0,
        background: '#0a0a0a',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: done ? 'none' : 'all',
      }}
    >
      <div style={{ position: 'relative', width: '140px', height: '140px' }}>
        {/* Spinning arc */}
        <svg
          style={{
            position: 'absolute',
            inset: 0,
            animation: 'spin 1.2s linear infinite',
          }}
          width="140"
          height="140"
          viewBox="0 0 140 140"
        >
          <circle
            cx="70"
            cy="70"
            r="62"
            fill="none"
            stroke="#3FC4E3"
            strokeWidth="4"
            strokeLinecap="round"
            strokeDasharray="290 110"
          />
        </svg>
        {/* Logo centered inside */}
        <img
          src={tccLogo}
          alt="TCCplus"
          style={{
            position: 'absolute',
            inset: 0,
            margin: 'auto',
            width: '90px',
            height: '90px',
            objectFit: 'contain',
            mixBlendMode: 'screen',
          }}
        />
      </div>
    </div>
  );
}

export default function App() {
  const [preloaderDone, setPreloaderDone] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setPreloaderDone(true), 1200);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      <ScrollProgress />
      <Preloader done={preloaderDone} />
      <Navbar />
      <main>
        <Hero />
        <About />
        <HowItWorks />
        <NonProfits />
        <PeopleInNeed />
        <Team />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
